module.exports = "/_next/static/images/bank-bri-icon-1c04705d909738456a538e4bf07712fe.svg";